module.exports = __webpack_public_path__ + "img/item-1.6362ab48.png";